export default __webpack_public_path__ + "static/media/miguel-lopes-2.1db2c844.jpg";